import { makeAutoObservable } from "mobx";
import { IRootStore } from "../../mobx/root-store.tsx";

export interface IFiboGenerateStore {
	generate: () => Promise<void>;
	stopGenerate: () => void;
	reset: () => void;
}

export default class FiboGenerateStore implements IFiboGenerateStore {
	rootStore: IRootStore;

	constructor(rootStore: IRootStore) {
		makeAutoObservable(this);
		this.rootStore = rootStore;
	}

	generate = async (): Promise<void> => {
		const { fiboStore } = this.rootStore;
		await fiboStore.generate();
	};

	stopGenerate = (): void => {
		const { fiboStore } = this.rootStore;
		fiboStore.abortImageGeneration();
	};

	reset = (): void => {
		const { textToImageStore } = this.rootStore;
		textToImageStore.clearConfig();
	};
}
